"use strict";
var ng_redux_1 = require('./components/ng-redux');
exports.NgRedux = ng_redux_1.NgRedux;
var dev_tools_1 = require('./components/dev-tools');
exports.DevToolsExtension = dev_tools_1.DevToolsExtension;
var select_1 = require('./decorators/select');
exports.select = select_1.select;
var ng_redux_module_1 = require('./ng-redux.module');
exports.NgReduxModule = ng_redux_module_1.NgReduxModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/ng2-redux/lib/index.js
// module id = ../../../../ng2-redux/lib/index.js
// module chunks = 3